import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { AuthService } from "../../../../@core/auth/auth.service";
import { Observable } from "rxjs";
import { PurchaseOrder } from "../models/purchaseOrder";
import { HandlingUnitMasterDTO } from "../../inventory/models/handling-unit-master";

@Injectable({
  providedIn: "root",
})
export class PurchaseOrderService {
  protected basePath = "/";

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  //Create purchase order with erp flag
  public createPO(
    po: PurchaseOrder,
    saveERPFlag?: boolean
  ): Observable<PurchaseOrder> {

    let queryParameters = new HttpParams();
    if (saveERPFlag) {
      queryParameters = queryParameters.set(
        "saveERPFlag",
        saveERPFlag.toString()
      );
    }

    return this.httpClient.post<any>(`${this.basePath}/api/purchaseorder`, po, {
      params: queryParameters
    });
  }

  //Update purchase order with erp flag false default for now
  public updatePO(
    po: PurchaseOrder,
    saveERPFlag?: boolean, methodName?: string
  ): Observable<PurchaseOrder> {

    let queryParameters = new HttpParams();
    if (saveERPFlag) {
      queryParameters = queryParameters.set(
        "saveERPFlag",
        saveERPFlag.toString()
      );
    }

    if (methodName) {
      queryParameters = queryParameters.set(
        "methodName",
        methodName.toString()
      );
    }

    return this.httpClient.put<any>(
      `${this.basePath}/api/purchaseorder/${po.id}`,
      po,
      {
        params: queryParameters
      }
    );
  }

  //To get all active POs
  getPOList() {
    return this.httpClient.get(`${this.basePath}/api/purchaseorder/getAll`);
  }

  //Delete purchase order based on Id
  public deletePurchaseOrder(poId: number, saveERPFlag?: boolean) {
    let queryParameters = new HttpParams();
    if (saveERPFlag) {
      queryParameters = queryParameters.set(
        "saveERPFlag",
        saveERPFlag.toString()
      );
    }

    return this.httpClient.delete(
      `${this.basePath}/api/purchaseorder/${poId}`,
      {
        params: queryParameters
      }
    );
  }

  //To get all active POs by latest offer no
  getPOfferNo(vendorId, varietyId, cropYearId) {
    let queryParameters = new HttpParams();
    if (vendorId) {
      queryParameters = queryParameters.set(
        "vendorId",
        vendorId
      );
    }
    if (varietyId) {
      queryParameters = queryParameters.set(
        "varietyId",
        varietyId
      );
    }
    if (cropYearId) {
      queryParameters = queryParameters.set(
        "cropYearId",
        cropYearId
      );
    }

    return this.httpClient.get(`${this.basePath}/api/purchaseorder/GetPOByLatestOfferNo`, {
      params: queryParameters
    });
  }

  //create purchase receipt
  public createPR(po: HandlingUnitMasterDTO[], saveERPFlag?: boolean): Observable<HandlingUnitMasterDTO[]> {
    let queryParameters = new HttpParams();
    if (saveERPFlag) {
      queryParameters = queryParameters.set(
        "saveERPFlag",
        saveERPFlag.toString()
      );
    }

    return this.httpClient.post<any>(`${this.basePath}/api/purchaseorder/createpurchasereceipt`, po, {
      params: queryParameters
    });
  }
}
